import france from '@/assets/twemoji/svg/1f1eb-1f1f7.svg'
import portugal from '@/assets/twemoji/svg/1f1f5-1f1f9.svg'
import japan from '@/assets/twemoji/svg/1f1ef-1f1f5.svg'
import sriLanka from '@/assets/twemoji/svg/1f1f1-1f1f0.svg'
import southAfrica from '@/assets/twemoji/svg/1f1ff-1f1e6.svg'

interface IProps {
    country: string;
}

// Source to find additional codes:
// https://emojipedia.org/
// Codepoints

function GenerateFlag(props: IProps) {
    const countries = [
        {
            name: "France",
            flag: france,
        },
        {
            name: "Portugal",
            flag: portugal,
        },
        {
            name: "Japan",
            flag: japan,
        },
        {
            name: "Sri Lanka",
            flag: sriLanka,
        },
        {
            name: "South Africa",
            flag: southAfrica,
        }
    ];

    const flag = countries.find(x => x.name === props.country);

    if (flag) {
        return (<>
            <img className="w-4" src={flag.flag} alt={props.country} />
        </>
        );
    } else {
        return (
            <span>{props.country}</span>
        );
    }
}

export default GenerateFlag;